var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1366 1366",
    width: 300,
    height: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Dynamic_Info Page-ai") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ffffff } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Zoom"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m647.3 766c-6.5 0-11.7-5.3-11.7-11.8v-235.3c0-6.5 5.2-11.7 11.7-11.7 6.5 0 11.8 5.2 11.8 11.7v235.3c0 6.5-5.3 11.8-11.8 11.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m765 648.3h-235.3c-6.5 0-11.8-5.2-11.8-11.7 0-6.5 5.3-11.8 11.8-11.8h235.3c6.5 0 11.7 5.3 11.7 11.8 0 6.5-5.2 11.7-11.7 11.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m647.3 883.6c-136.2 0-247-110.8-247-247 0-136.2 110.8-247.1 247-247.1 136.2 0 247 110.9 247 247.1 0 136.2-110.8 247-247 247zm0-470.5c-123.2 0-223.5 100.2-223.5 223.5 0 123.2 100.3 223.5 223.5 223.5 123.3 0 223.5-100.3 223.5-223.5 0-123.3-100.2-223.5-223.5-223.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m1007.1 1048.3c-9.5 0-18.4-3.7-25-10.5l-145.9-145.9c-54.9 40.8-119.9 62.3-188.9 62.3-84.8 0-164.6-33.1-224.6-93.1-59.9-59.9-93-139.7-93-224.5 0-84.9 33.1-164.6 93-224.6 60-60 139.8-93 224.6-93 84.9 0 164.6 33 224.6 93 60 60 93 139.7 93 224.6 0 68.9-21.5 134-62.2 188.8l145.9 146c6.7 6.6 10.5 15.5 10.5 24.9 0 9.5-3.8 18.4-10.5 25l-16.5 16.6c-6.7 6.7-15.5 10.4-25 10.4zm-169.9-183.8c3 0 6 1.2 8.3 3.5l153.3 153.2c2.2 2.3 5.2 3.6 8.3 3.6 3.1 0 6.1-1.3 8.3-3.5l16.6-16.6c2.3-2.3 3.5-5.2 3.5-8.4 0-3.1-1.2-6-3.4-8.2l-153.4-153.4c-4.2-4.2-4.6-10.9-0.9-15.6 41.6-52.3 63.6-115.4 63.6-182.5 0-162.2-131.9-294.1-294.1-294.1-162.1 0-294 131.9-294 294.1 0 162.1 131.9 294 294 294 67.1 0 130.2-21.9 182.6-63.5 2.1-1.7 4.7-2.6 7.3-2.6z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoom);
export default __webpack_public_path__ + "static/media/zoom.2e3a7d27bc9a0d9ed014d1f89e6a9be7.svg";
export { ForwardRef as ReactComponent };